export default __webpack_public_path__ + "static/media/aud.40065ace.webp";